export default {
  DefaultGlobalList: 'defaultApproverList',
  UserDefinedList: 'userDefinedApproverList',
}
